export default __webpack_public_path__ + "static/media/learn.4539a1f0.svg";